import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
// import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import {
  CloseOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Drawer, Tooltip, Typography } from "antd";
import {
  EmailIcon,
  FacebookIcon,
  InstagramIcon,
  MobileIcon,
  NoteArrowIcon,
  SnapchatIcon,
  TwitterIcon,
} from "assets/icons";
import { NOTE_TYPE } from "constants/appConstant";
import moment from "moment";
import CustomerForm from "pages/admin/customer/customerForm";
import { getConversationSelected } from "stores/slices/conversation";
import {
  doGetCustomerDetail,
  fecthCustomerDetail,
} from "stores/slices/customer";
import { doGetAllCustomField } from "stores/slices/customField";
import { doGetNoteListByCustomer, doRemoveNote } from "stores/slices/note";
import { getUserDetail, getUserList } from "stores/slices/user";

import AppButton from "components/button";
import ModalForm from "components/forms/components/modalForm";
import EditorQuill from "components/inputs/editorQuill";

import NoteForm from "./noteForm";

import "../../../assets/styles/dropDownStyle.scss";

const ChatCustomerInfo = props => {
  const { isOpenLayoutRight, setIsOpenLayoutRight, urlParam, authInfo } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const customerFormRef = useRef();
  const customerInfo = useSelector(fecthCustomerDetail);
  const conversationSelected = useSelector(getConversationSelected);
  const userInfo = useSelector(getUserDetail);

  const [customFields, setCustomFields] = useState([]);
  const [isOpenCustomerForm, setIsOpenCustomerForm] = useState(false);
  const [isOpenNoteForm, setOpenNoteForm] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [noteListOfCustomer, setNoteListOfCustomer] = useState([]);
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [isLoadingNote, setIsLoadingNote] = useState(false);
  // const [isUpdateBroadcastTable, setIsUpdateBroadcastTable] = useState(false);
  // const [initialValues, setInitialValues] = useState(null);
  // console.log(isUpdateBroadcastTable, initialValues);

  const onClose = () => {
    setIsOpenLayoutRight(false);
  };

  const handleDeleteNote = async noteId => {
    setIsRefresh(false);
    if (noteId) {
      const { payload } = await dispatch(doRemoveNote({ id: noteId }));
      if (payload && payload.status === 200) {
        setIsRefresh(true);
        setIsOpenModalDelete(false);
        setIsDeleting(false);
      }
    }
  };

  const getListCustomField = async () => {
    if (authInfo.workspaceId) {
      const result = await dispatch(doGetAllCustomField(authInfo.workspaceId));
      if (result) {
        setCustomFields(result.payload);
      }
    }
  };

  const getListNoteByCustomer = async customerId => {
    setIsLoadingNote(true);
    const { payload } = await dispatch(
      doGetNoteListByCustomer({ customerId: customerId })
    );
    if (payload && payload.status === 200) {
      setNoteListOfCustomer([...payload.data]);
      setIsLoadingNote(false);
    } else {
      setIsLoadingNote(false);
    }
  };

  const handleTitleDelete = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <QuestionCircleOutlined style={{ color: "red", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("inbox.chatCustomerInfo.deleteNote")}
        </span>
      </div>
    );
  };
  const formatTimeAgo = seconds => {
    const date = moment(seconds)
      ?.locale("en-au", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          w: "a week",
          ww: "%d weeks",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years",
        },
      })
      ?.tz(userInfo?.timeZone ? userInfo?.timeZone : moment.tz.guess())
      ?.fromNow();
    return date;
  };

  const NoteCustomerItem = props => {
    const { note } = props;
    const users = useSelector(getUserList);

    const userInfo = users.find(user => user?.id === note?.userId);

    return (
      <>
        <div
          style={{
            width: "fit-content",
            maxWidth: "300px",
            background: "#ffde8a",
            borderRadius: "10px",
            borderTopRightRadius: "14px",
            position: "relative",
            marginTop: 12,
            padding: 12,
          }}
        >
          <div
            style={{
              fontSize: 14,
              fontWeight: 500,
              maxWidth: "300px",
              whiteSpace: "wrap",
            }}
          >
            <span>
              {userInfo?.firstName || userInfo?.lastName
                ? `${userInfo?.firstName} ${userInfo?.lastName}`
                : `${userInfo && userInfo.phoneNumber}`}
            </span>
          </div>
          <div style={{ padding: "8px 0" }}>
            <EditorQuill
              readOnly={true}
              customClassName="customScrollbar borderNone noPaddingContainer"
              value={note?.note}
            />
          </div>
          <span
            style={{
              position: "absolute",
              top: "-2px",
              right: "-2px",
            }}
          >
            <NoteArrowIcon />
          </span>
          <span
            style={{
              position: "absolute",
              left: -10,
              top: -10,
              bottom: 32,
              zIndex: 1,
            }}
          >
            <Button
              shape="circle"
              size="small"
              onClick={() => {
                setSelectedNote(note);
                setIsOpenModalDelete(true);
              }}
            >
              <CloseOutlined />
            </Button>
          </span>
          <div
            style={{
              fontSize: 12,
              fontWeight: 500,
            }}
          >
            <span>{formatTimeAgo(note?.createdTime)}</span>
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    if (authInfo && authInfo.workspaceId) {
      getListCustomField();
    }
  }, [authInfo?.workspaceId]);

  useEffect(() => {
    if (
      conversationSelected &&
      conversationSelected.customerId &&
      urlParam?.id !== "messages"
    ) {
      dispatch(doGetCustomerDetail({ id: conversationSelected.customerId }));
      getListNoteByCustomer(conversationSelected.customerId);
    }
  }, [isOpenLayoutRight]);

  useEffect(() => {
    if (isRefresh && conversationSelected && conversationSelected.customerId) {
      getListNoteByCustomer(conversationSelected.customerId);
    }
  }, [isRefresh]);

  return (
    <>
      {isOpenLayoutRight && (
        <div className="chatUserInfo">
          <Drawer
            placement={"right"}
            width={370}
            closable={true}
            maskClosable={false}
            mask={false}
            open={isOpenLayoutRight}
            onClose={onClose}
            className="chatUserInfoDrawer"
          >
            <div className="chatUserInfoContainer">
              <div className="chatUserInfoHeader">
                <Avatar
                  type="circle"
                  size={64}
                  icon={<UserOutlined />}
                  src={conversationSelected?.profileImage || ""}
                />
                <Typography.Text className="chatUserInfoHeaderTitle">
                  {customerInfo?.firstName && customerInfo?.lastName
                    ? `${customerInfo.firstName || ""} ${
                        customerInfo.lastName || ""
                      }`
                    : customerInfo?.contact?.phoneNumber}
                </Typography.Text>
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    marginTop: "8px",
                    marginRight: "8px",
                  }}
                >
                  <Tooltip title="Edit customer">
                    <Button
                      type="text"
                      shape="circle"
                      size="large"
                      onClick={() => setIsOpenCustomerForm(true)}
                    >
                      <EditOutlined
                        style={{
                          fontSize: "20px",
                        }}
                      />
                    </Button>
                  </Tooltip>
                </div>
              </div>
              <div className="chatUserInfoBody">
                <div className="chatUserInfoBodyList">
                  <div>
                    <div className="chatUserInfoBodyItem">
                      <div className="chatUserInfoBodyAvatar">
                        <MobileIcon />
                      </div>
                      <div>
                        <Typography.Text className="chatUserInfoBodyItemTitle">
                          {t("inbox.chatCustomerInfo.mobileNumber")}
                        </Typography.Text>
                        <Typography.Text className="chatUserInfoBodyItemDesc">
                          {customerInfo?.contact?.phoneNumber
                            ? customerInfo?.contact?.phoneNumber
                            : "-"}
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="chatUserInfoBodyItem">
                      <div className="chatUserInfoBodyAvatar">
                        <EmailIcon />
                      </div>
                      <div>
                        <Typography.Text className="chatUserInfoBodyItemTitle">
                          {t("inbox.chatCustomerInfo.email")}
                        </Typography.Text>
                        <Typography.Text className="chatUserInfoBodyItemDesc">
                          {customerInfo?.contact?.email
                            ? customerInfo?.contact?.email
                            : "-"}
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="chatUserInfoBody">
                <div className="chatUserInfoBodyList">
                  <div>
                    <div className="chatUserInfoBodyItem">
                      <div className="chatUserInfoBodyAvatar">
                        <FacebookIcon width={20} height={20} />
                      </div>
                      <div>
                        <Typography.Text className="chatUserInfoBodyItemTitle">
                          {t("inbox.chatCustomerInfo.facebook")}
                        </Typography.Text>
                        <Typography.Text className="chatUserInfoBodyItemDesc">
                          {customerInfo?.contact?.facebook
                            ? customerInfo?.contact?.facebook
                            : "-"}
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="chatUserInfoBodyItem">
                      <div className="chatUserInfoBodyAvatar">
                        <InstagramIcon width={20} height={20} />
                      </div>
                      <div>
                        <Typography.Text className="chatUserInfoBodyItemTitle">
                          {t("inbox.chatCustomerInfo.instagram")}
                        </Typography.Text>
                        <Typography.Text className="chatUserInfoBodyItemDesc">
                          {customerInfo?.contact?.instagram
                            ? customerInfo?.contact?.instagram
                            : "-"}
                        </Typography.Text>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="chatUserInfoBodyItem">
                      <div
                        className="chatUserInfoBodyAvatar"
                        style={{ paddingRight: 12 }}
                      >
                        <TwitterIcon width={16} height={16} />
                      </div>
                      <div>
                        <Typography.Text className="chatUserInfoBodyItemTitle">
                          {t("inbox.chatCustomerInfo.twitter")}
                        </Typography.Text>
                        <Typography.Text className="chatUserInfoBodyItemDesc">
                          {customerInfo?.contact?.twitter
                            ? customerInfo?.contact?.twitter
                            : "-"}
                        </Typography.Text>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="chatUserInfoBodyItem">
                      <div
                        className="chatUserInfoBodyAvatar"
                        style={{ paddingRight: 7 }}
                      >
                        <SnapchatIcon width={21} height={21} />
                      </div>
                      <div>
                        <Typography.Text className="chatUserInfoBodyItemTitle">
                          {t("inbox.chatCustomerInfo.snapchat")}
                        </Typography.Text>
                        <Typography.Text className="chatUserInfoBodyItemDesc">
                          {customerInfo?.contact?.snapchat
                            ? customerInfo?.contact?.snapchat
                            : "-"}
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="chatUserInfoFooter">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography.Text className="chatUserInfoFooterTitle">
                    {t("inbox.chatCustomerInfo.notes")}
                  </Typography.Text>
                  <Tooltip title="Add note">
                    <Button
                      type="text"
                      shape="circle"
                      size="large"
                      onClick={() => setOpenNoteForm(true)}
                    >
                      <EditOutlined
                        style={{
                          fontSize: "20px",
                        }}
                      />
                    </Button>
                  </Tooltip>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "0 12px",
                  }}
                >
                  {/* <div
                        id="scrollableNoteList"
                        style={{
                          height: "280px",
                          overflow: "auto",
                          marginTop: "10px",
                        }}
                      > */}
                  {/* <InfiniteScroll
                          scrollableTarget="scrollableDiv"
                          dataLength={noteList.length}
                          endMessage={""}
                        > */}
                  {!isLoadingNote &&
                    noteListOfCustomer &&
                    noteListOfCustomer.length === 0 && (
                      <>
                        <div>
                          <Typography.Title level={5}>
                            No note available
                          </Typography.Title>
                        </div>
                      </>
                    )}
                  {!isLoadingNote &&
                    noteListOfCustomer &&
                    noteListOfCustomer.length > 0 && (
                      <>
                        {noteListOfCustomer?.map((noteItem, index) => (
                          <>
                            <NoteCustomerItem key={index} note={noteItem} />
                          </>
                        ))}
                      </>
                    )}
                  {/* </InfiniteScroll> */}
                  {/* </div> */}
                </div>
              </div>
            </div>
          </Drawer>
        </div>
      )}
      <ModalForm
        title={t("customer.updateCustomer")}
        onCancel={() => {
          // customerFormRef?.current?.handleConfirmUnSave();
          setIsOpenCustomerForm(false);
        }}
        isOpen={isOpenCustomerForm}
        destroyOnClose={true}
        labelSubmit={t("label.save")}
        customWidth={700}
        footer={false}
      >
        <CustomerForm
          ref={customerFormRef}
          customerSelected={customerInfo}
          isOpenCustomerForm={isOpenCustomerForm}
          setIsOpenCustomerForm={setIsOpenCustomerForm}
          customFields={customFields}
          userType={authInfo?.type}
        />
      </ModalForm>
      <ModalForm
        title={t("inbox.chatMessage.addNote")}
        onCancel={() => setOpenNoteForm(false)}
        destroyOnClose={true}
        isOpen={isOpenNoteForm}
        labelSubmit={t("label.save")}
        customWidth={500}
        footer={false}
      >
        <NoteForm
          setOpenNoteForm={setOpenNoteForm}
          conversationSelected={conversationSelected}
          noteType={NOTE_TYPE.CUSTOMER}
          setIsRefresh={setIsRefresh}
        />
      </ModalForm>
      <ModalForm
        isOpen={isOpenModalDelete}
        type="confirm"
        title={handleTitleDelete()}
        onCancel={() => {
          setIsOpenModalDelete(false);
        }}
        okType={"danger"}
        danger={true}
        destroyOnClose={true}
        maskClosable={false}
        footer={[
          <AppButton
            key="button"
            label={t("button.cancel")}
            color={"grey"}
            loading={isDeleting}
            disabled={isDeleting}
            htmlType="button"
            onClick={() => {
              setIsOpenModalDelete(false);
            }}
          />,
          <AppButton
            key="button"
            color="red"
            label={t("button.delete")}
            loading={isDeleting}
            disabled={isDeleting}
            onClick={() => {
              setIsDeleting(true);
              handleDeleteNote(selectedNote.id);
            }}
          />,
        ]}
      >
        <div style={{ height: 50, marginLeft: 35, fontSize: 14 }}>
          {t("inbox.chatCustomerInfo.deleteNoteMsg")}
        </div>
      </ModalForm>
    </>
  );
};

export default ChatCustomerInfo;
